import { Delete, Upload } from "@mui/icons-material";
import { Avatar, Button, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import * as React from "react";

const UploadLogo = ({
  onChange,
  value,
}: {
  onChange: (file: File | null) => void;
  value?: string;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [image, _setImage] = React.useState<string | null>(null);
  const inputFileRef = React.createRef<HTMLInputElement>();

  const cleanup = () => {
    if (!!image) URL.revokeObjectURL(image!);

    inputFileRef!.current!.value = "";
  };

  const setImage = (newImage: string | null) => {
    if (image) cleanup();

    _setImage(newImage);
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newImage = event.target?.files?.[0];
    if (newImage) {
      const objectUrl = URL.createObjectURL(newImage);
      setImage(objectUrl);

      onChange(newImage);
    }
  };

  const handleClick = (event: any) => {
    if (image) {
      event.preventDefault();
      setImage(null);
    }
  };

  return (
    <Stack 
      direction={isMobile ? "column" : "row"} 
      alignItems={isMobile ? "flex-start" : "center"}
      spacing={isMobile ? 2 : 0}
    >
      <Avatar
        variant="square"
        sx={{ 
          bgColor: "primary.main", 
          height: { xs: 80, sm: 100 }, 
          width: { xs: 80, sm: "auto" },
          mr: { xs: 0, sm: 2 },
          mb: { xs: 0, sm: 0 },
          maxWidth: { xs: "100%", sm: "none" },
          objectFit: "contain",
        }}
        src={image || value || "./broken-image.jpg"}
      />
      <input
        ref={inputFileRef}
        accept="image/*"
        hidden
        id="logo-image-upload"
        type="file"
        onChange={handleOnChange}
      />
      <label htmlFor="logo-image-upload" style={{ width: isMobile ? "100%" : "auto" }}>
        <Button
          variant="outlined"
          component="span"
          onClick={handleClick}
          fullWidth={isMobile}
          sx={{
            borderColor: "#F4A259",
            color: "#F4A259",
            "&:hover": {
              borderColor: "#F4A259",
              backgroundColor: "rgba(244, 162, 89, 0.08)",
            },
          }}
        >
          <>
            {image ? <Delete /> : <Upload />}
            {image ? "Reset" : "Select Logo"}
          </>
        </Button>
      </label>
      {/* <Typography variant="caption" display="block" gutterBottom>
      </Typography> */}
    </Stack>
  );
};
export default UploadLogo;
